// extracted by mini-css-extract-plugin
export default {"tupacGrid":"si-z","tupacHeader":"ti-z","tupacHeader2":"ui-z","tupacMenu":"vi-z","tupacMenu2":"wi-z","tupacMain":"xi-z","tupacMain2":"yi-z"};